"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bson_1 = require("bson");
var buffer_1 = require("buffer");
var blobparserv1_1 = require("./blobparserv1");
var blobparserv2_1 = require("./blobparserv2");
// Blobs are encrypted binary data stored on S3 for Pasty.
// Format can differ depending on what version of Pasty encrypted
// them. Either it's base64-encoded data or a BSON-encoded blob.
//
// Returns a BlobParser depending on the version. It wraps decryption
// functionality.
var BlobParser = /** @class */ (function () {
    function BlobParser() {
    }
    BlobParser.parse = function (data, name, key) {
        var parser;
        var bson = new bson_1.BSON();
        try {
            var results = bson.deserialize(buffer_1.Buffer.from(data));
            if (results.version === 2) {
                return new blobparserv2_1.default(results, name, key);
            }
            else {
                throw new Error("Unknown blob API version: \"" + results.version + "\".");
            }
        }
        catch (e) {
            return new blobparserv1_1.default(buffer_1.Buffer.from(data).toString('utf8'), name, key);
        }
    };
    return BlobParser;
}());
exports.default = BlobParser;
